import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export const SUPER_ADMIN_EMAIL = 'admin@vietnam.st';

export function useAdminRole() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function resolveRole() {
      try {
        const { data } = await supabase.auth.getSession();
        const user = data.session?.user;
        if (!cancelled) setIsSuperAdmin(user?.email === SUPER_ADMIN_EMAIL);
      } catch {
        if (!cancelled) setIsSuperAdmin(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    resolveRole();
    return () => {
      cancelled = true;
    };
  }, []);

  return { isSuperAdmin, loading };
}